// Libraries
import styled, { css } from 'styled-components'

type Props = {
  error?: boolean
  filled?: boolean
  disabled?: boolean
  type?: string
}

const InputStyle = css<Props>`
  background-color: ${({ theme }) => theme.colors.white01};
  border-radius: 4px;
  caret-color: ${({ theme }) => theme.colors.gray04};
  color: ${({ theme }) => theme.colors.blueDarkerDefault};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-family: ${({ theme }) => theme.fontFamily.lato};
  font-size: ${({ theme }) => theme.fontSize.small};
  min-width: 392px;
  outline: none;
  padding: 18px 17px 0px 17px;
  transition: all 0.2s ease;
`

export const Container = styled.div<Props>`
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
`

export const Label = styled.p<Props>`
  background-color: ${({ theme, type }) =>
    type === 'textarea' ? theme.colors.white01 : 'transparent'};
  color: ${({ filled, theme, error, disabled }) =>
    disabled
      ? theme.colors.gray05
      : error
      ? theme.colors.red
      : filled
      ? theme.colors.purpleDefault
      : theme.colors.gray04};
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-size: ${({ theme, filled }) =>
    filled ? theme.fontSize.xxsmall : theme.fontSize.xsmall};
  position: absolute;
  pointer-events: none;
  transition: all 0.2s ease;
  transform: ${({ filled }) =>
    filled ? 'translateY(-21px)' : 'translateY(-50%)'};
  left: 17px;
  top: 10px;
  user-select: none;
  border-top: solid ${({ filled }) => (filled ? '5' : '0')}px
    ${({ theme, type }) =>
      type === 'textarea' ? theme.colors.white01 : 'transparent'};
  width: calc(100% - 35px);
`

export const Input = styled.input<Props>`
  border: 1px solid
    ${({ theme, error, filled, disabled }) => {
      return disabled
        ? 'transparent'
        : error
        ? theme.colors.red
        : filled
        ? theme.colors.purpleDefault
        : 'transparent'
    }};
  height: 48px;
  :focus {
    border: 1px solid
      ${({ theme, error, filled }) => {
        return error
          ? theme.colors.red
          : filled
          ? theme.colors.purpleLight
          : theme.colors.purpleLighter
      }};
  }
  :hover {
    border: 1px solid
      ${({ theme, error, disabled }) =>
        disabled
          ? 'transparent'
          : error
          ? theme.colors.red
          : theme.colors.purpleLighter};
  }
  ${InputStyle};
`

export const TextArea = styled.textarea<Props>`
  border: 1px solid
    ${({ theme, error, filled, disabled }) =>
      disabled
        ? 'transparent'
        : error
        ? theme.colors.red
        : filled
        ? theme.colors.purpleDefault
        : 'transparent'};
  height: 90px;
  resize: none;
  :focus {
    border: 1px solid
      ${({ theme, error, filled }) =>
        error
          ? theme.colors.red
          : filled
          ? theme.colors.purpleDefault
          : theme.colors.purpleDefault};
  }
  :hover {
    border: 1px solid
      ${({ theme, error, disabled }) =>
        disabled
          ? 'transparent'
          : error
          ? theme.colors.red
          : theme.colors.purpleLighter};
  }
  ${InputStyle};
`
